"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.starterFreeScopes = void 0;
var enum_1 = require("../enum");
exports.starterFreeScopes = [
    enum_1.Scopes.HotjarRead,
    enum_1.Scopes.SupplyTemplatesLendersRead,
];
